import { render, staticRenderFns } from "./EditSpouse.vue?vue&type=template&id=b03bbb1e&scoped=true&"
import script from "./EditSpouse.vue?vue&type=script&lang=js&"
export * from "./EditSpouse.vue?vue&type=script&lang=js&"
import style0 from "./EditSpouse.vue?vue&type=style&index=0&id=b03bbb1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03bbb1e",
  null
  
)

export default component.exports